import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../../collectionTraits/utils';
import { fieldTraitTextContentOptions } from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';

export const ImaginePayBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="wb webconnect-wallet"></i><div>${label}</div>`,
    category: category,
    content: `
    <button class="btn btn-primary btn-sm mx-2" data-gjs-type="${type}" data-gjs="${type}"
      data-gjs-custom-name="${label}">Buy now</button>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-wallet"></i>',
          projectId,
          resizable: true,
          traits: [...defaultModel.prototype.defaults.traits],
        },
        async init() {
          const collectionName = findParentCollection(this, config);
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            if (collectionResponse) {
              const collectionFieldOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              if (collectionFieldOptions) {
                const traits = [
                  { label: 'Online Provider ID', name: 'provider_id', title: 'provider_id' },
                  {
                    label: 'Online Account Number',
                    name: 'account_number',
                    title: 'account_number',
                  },
                  { label: 'Patient Date of Birth', name: 'dob', title: 'dob' },
                  { label: 'Patient First Name', name: 'first_name', title: 'first_name' },
                  { label: 'Patient Last Name', name: 'last_name', title: 'last_name' },
                  { label: 'Balance', name: 'balance', title: 'balance' },
                  { label: 'Amount', name: 'amount', title: 'amount' },
                  {
                    label: 'Service Description',
                    name: 'service_description',
                    title: 'service_description',
                  },
                  { label: 'Note', name: 'note', title: 'note' },
                ];
                traits.map((trait) =>
                  this.addTrait({
                    label: trait.label,
                    name: trait.name,
                    title: trait.title,
                    type: 'data-imagine-pay-trait',
                    options: collectionFieldOptions,
                  }),
                );
              }
              const { fields } = collectionResponse;
              const collectionReferenceFields =
                fields && fields.length > 0
                  ? fields.filter((crd) => crd.type === FieldTypes.reference.id)
                  : [];
              this.setAttributes({
                selectedCollectionData: JSON.stringify(collectionReferenceFields),
                onclick: 'imaginePayCheckout(event)',
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
};
